import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, Grid, Card, Typography, IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ViewHeader from 'components/rootComponents/Standards/ViewHeader/ViewHeader';
import useCharts from 'utils/customHooks/useCharts';
import { IUruguayGlobal } from '../UruguayGlobal.interface';
import useStyles from '../../../components/charts/Charts.styles';

const UruguayGlobalGraficas = (props: IUruguayGlobal) => {
  const { isLoadingCharts, charts } = useCharts(
    window.location.pathname,
    props.filters,
  );
  const yearFilter = props.filters.find((filter: any) => filter.codigo === "year");
  const selectedYear: string = String(yearFilter?.valor || 'No especificado');
  const classes = useStyles();
  const title = 'Inicio';
  const acumuladoGraduados: Record<string, string> = {
    "2019": "0",
    "2020": "0",
    "2021": "43",
    "2022": "80",
    "2023": "234",
    "2024": "375",
    "2025": "375"
  };
  const acumuladoMatriculados: Record<string, string> = {
    "2019": "58",
    "2020": "93",
    "2021": "156",
    "2022": "495",
    "2023": "608",
    "2024": "633",
    "2025": "633"
  };
  const dataPorAnio: Record<string, { title: string; total: string }[]> = {
    "2019": [
      { title: "Graduados totales", total: "0" },
      { title: "Matriculados totales", total: "58" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "58" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "0" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "0%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "55%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "17%" }
    ],
    "2020": [
      { title: "Graduados totales", total: "0" },
      { title: "Matriculados totales", total: "35" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "35" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "0" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "0%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "54%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "6%" }
    ],
    "2021": [
      { title: "Graduados totales", total: "43" },
      { title: "Matriculados totales", total: "63" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "63" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "0" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "74%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "48%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "25%" }
    ],
    "2022": [
      { title: "Graduados totales", total: "28" },
      { title: "Matriculados totales", total: "339" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "26" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "313" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "54%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "71%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "40%" }
    ],
    "2023": [
      { title: "Graduados totales", total: "150" },
      { title: "Matriculados totales", total: "113" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "27" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "86" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "46%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "100%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "47%" }
    ],
    "2024": [
      { title: "Graduados totales", total: "108" },
      { title: "Matriculados totales", total: "25" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "0" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "25" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "45%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "86%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "28%" }
    ],
    "2025": [
      { title: "Graduados totales", total: "108" },
      { title: "Matriculados totales", total: "25" },
      { title: "Número de nuevos inscriptos en programas de posgrado", total: "0" },
      { title: "Número de nuevos inscriptos en programas de formación continua", total: "25" },
      { title: "Porcentaje de graduados de programas de postgrado", total: "45%" },
      { title: "Porcentaje de mujeres que son becadas sobre matriculadas para programas de postgrado", total: "86%" },
      { title: "Porcentaje de docentes UTEC capacitados en temáticas de cambio climático", total: "0%" },
      { title: "Tasa de matriculados en programas, residentes en Uruguay, que son residentes en regiones", total: "28%" }
    ]
  };
const downloadCSV = () => {
  const acumulado = [
    {
      title: 'Indicadores Acumulados - Graduados totales',
      total: acumuladoGraduados[selectedYear] || '0',
    },
    {
      title: 'Indicadores Acumulados - Matriculados totales.',
      total: acumuladoMatriculados[selectedYear] || '0',
    },
  ];
  const anuales = (dataPorAnio[selectedYear] || []).map((item) => ({
    title: `Indicadores Anuales - ${item.title}`,
    total: item.total || '0',
  }));
  const datosCombinados = [...acumulado, ...anuales];
  if (datosCombinados.length === 0) {
    console.error('No hay datos disponibles para descargar');
    return;
  }
  const headers = ['Indicador', 'Valor', 'Año'];
  const rows = datosCombinados.map((item) => [item.title, item.total, selectedYear]);
  const tsvContent = [headers, ...rows].map((row) => row.join('\t')).join('\n');
  const blob = new Blob([tsvContent], { type: 'text/tab-separated-values;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `indicadores-${selectedYear}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  if (isLoadingCharts) {
    return (
      <Grid container spacing={2} style={{ alignItems: 'center', marginTop: '0px', textAlign: 'center' }}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container spacing={2} style={{ alignItems: 'center', marginTop: '0px', paddingLeft: '20px' }}>
      <Grid item xs={12}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px' }}>
          <ViewHeader title={title} />
          <IconButton onClick={downloadCSV}>
            <DownloadIcon sx={{ color: '#007BFF' }} />
          </IconButton>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" color="black" fontWeight="bold">
          Indicadores Acumulados
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" fontWeight="bold">
          Muestra los datos acumulados del Programa.
        </Typography>
      </Grid>
      {[
        { title: "Graduados totales", total: acumuladoGraduados[selectedYear] || '-' },
        { title: "Matriculados totales", total: acumuladoMatriculados[selectedYear] || '-' }
      ].map((card, index) => (
        <Grid item key={`acumulado-${index}`} xs={12} sm={6} md={6}>
          <Card style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#E6F5F9', padding: '16px', height: '100px' }}>
            <Typography variant="h4" fontWeight="bold">{card.total}</Typography>
            <Typography variant="body1" style={{ textAlign: 'right' }}>{card.title}</Typography>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12} mt={2}>
        <Typography variant="h6" color="black" fontWeight="bold">
          Indicadores Anuales
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" fontWeight="bold">
          Muestra los datos para el año seleccionado.
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" fontWeight="bold">
          Componente I - Capital Humano Digital
        </Typography>
      </Grid>
      {(dataPorAnio[selectedYear] || []).map((card, index) => (
        <Grid item key={index} xs={12} sm={6} md={6}>
          <Card style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f5f5f5', padding: '16px', height: '100px' }}>
            <Typography variant="h4" fontWeight="bold">{card.total}</Typography>
            <Typography variant="body1" style={{ textAlign: 'right' }}>
              {card.title}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
const mapStateToProps = (state: any) => {
  return { filters: state.filters };
};
export default connect(mapStateToProps)(UruguayGlobalGraficas);
